/** @jsxImportSource @emotion/react */
import { css, SerializedStyles } from "@emotion/react";

import { ReactNode } from "react";

import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

import { colors } from "@dotnet/telematics-design-system";

import InfoIconWithTooltip from "../../../../../IconsWithTooltips/InfoIconWithTooltip/InfoIconWithTooltip";
import { useStyles } from "../../Dialogs/styles";

interface ContentBoxProps {
  children: ReactNode;
  title: string;
  noFlex?: boolean;
  description?: string;
  css?: SerializedStyles;
}

const ContentBox = ({
  children,
  title,
  noFlex,
  description,
  ...props
}: ContentBoxProps) => {
  const { contentBoxTitleBlock, contentBoxPaper } = useStyles({
    colors,
    noFlex
  });

  return (
    <div {...props}>
      <div css={css(contentBoxTitleBlock)}>
        <Typography variant="body1Medium" sx={{ color: colors.textDark }}>
          {title}
        </Typography>

        {description && (
          <InfoIconWithTooltip
            title={description}
            customIconStyle={{ marginLeft: "4px" }}
          />
        )}
      </div>

      <Paper elevation={0} variant="outlined" sx={contentBoxPaper as {}}>
        {children}
      </Paper>
    </div>
  );
};

export default ContentBox;
